import React from "react";
import {
  Elements,
  CardElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { functions } from "../../../firebase";
import styles from "./styles.module.css";
const createSetupIntent = functions.httpsCallable("createSetupIntent");
const getPortalLink = functions.httpsCallable("getPortalLink");
const stripePromise = loadStripe(
  "pk_test_51HfC3sBLTRLftxZQnjzimRDVusPQq4pCOPlo4HhR7LVZ60GNxrjPKzQJYrsnXfEOYbLvROLJQfhMYmW9NPg1zP6G00s6mkO05e"
);

export default function Billing({ billing }) {
  return (
    <div>
      {billing && billing.customerId ? (
        <VisitPortal billing={billing} />
      ) : (
        <AddCard billing={billing} />
      )}
    </div>
  );
}

const VisitPortal = () => {
  const openPortal = async () => {
    const {
      data: { link, error },
    } = await getPortalLink({
      returnUrl: window.location.href,
    });

    if (error) {
      return alert("Couldn't open portal at this time");
    }
    window.open(link);
  };
  return (
    <div>
      <div className={styles.inputTitle}>
        Click the Link below to view your active subscriptions and billing
        portal
      </div>
      <button onClick={openPortal} className={styles.save}>
        Open
      </button>
    </div>
  );
};
const AddCard = ({ billing }) => {
  const [name, setName] = React.useState("");
  const [zipCode, setZipCode] = React.useState("");
  const stripe = useStripe();
  const elements = useElements();

  const handleSave = async () => {
    if (name.length === 0) {
      alert("Please enter the name on the card");
      return;
    }
    //create payment Method
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardElement),
      billing_details: {
        name: name,
      },
    });

    //handle Error
    if (error) {
      return alert("Sorry, but we couldn't save this card");
    }

    const {
      data: { error: _error },
    } = await createSetupIntent({ paymentMethodId: paymentMethod.id });

    if (_error) {
      return alert("Sorry, but we couldn't save this card");
    }

    console.log("Done");
  };

  return (
    <div>
      <div className={styles.inputTitle}>Name on Card</div>
      <input
        style={{ marginBottom: 12 }}
        value={name}
        onChange={(e) => setName(e.target.value)}
        className="input"
      />

      <div className={styles.inputTitle}>Enter Card Details</div>
      <CardElement
        options={{
          classes: { base: "input" },
        }}
      />
      <button onClick={handleSave} className={styles.save}>
        Save Card
      </button>
    </div>
  );
};
